import React from 'react';
import { Link } from 'react-router-dom';
import { BmwFront } from '../../../images/UberTorontoLinks';

const TorontoHeading = () => (
  <div className="toronto-heading">
    <div className="toronto-heading__left">
      <h1> Drive Uber without owning a car.</h1>
      <h4> Autzu will provide you a car to drive & earn with Uber in Toronto. No upfront costs or deposits. </h4>
      <Link to="/signup">
        <button className="toronto-heading__button">Sign up to drive</button>
      </Link>
    </div>
    <div className="toronto-heading__right">
      <img className="toronto-heading__right--image" alt="BMW 330i" src={BmwFront} />
    </div>
  </div>
);

export default TorontoHeading;



// WEBPACK FOOTER //
// ./src/components/Static/UberToronto/TorontoHeading.js